import React, { useEffect } from 'react'
import { Link } from 'gatsby'

import useStickyState from '../hooks/use-sticky-state'

import Logo from './Logo'
import Input from './Input'
import TradLink from '../components/TradLink'
import './Footer.css'

/* eslint-disable */

export default () => {
  const [time, setTime] = useStickyState(null, 'mode')
  const currentTime = new Date()
  const hour = currentTime.getHours() + (currentTime.getTimezoneOffset() % 60)

  let control = hour > 7 && hour < 19 ? 'day' : 'night'

  if (time !== null) {
    control = time
  }

  const onClick = () => {
    if (control === 'night') {
      setTime('day')
    } else {
      setTime('night')
    }
    control = time
  }

  const changeMode = () => {
    document.documentElement.style.setProperty(
      '--primary',
      control === 'night' ? '#ffffff' : '#000000'
    )
    document.documentElement.style.setProperty(
      '--body',
      control === 'night' ? '#e5e5e5' : '#333'
    )
    document.documentElement.style.setProperty(
      '--first-bg',
      control === 'night' ? '#000' : '#fff'
    )
    document.documentElement.style.setProperty(
      '--second-bg',
      control === 'night' ? '#121212' : '#fafafa'
    )
    document.documentElement.style.setProperty(
      '--stroke',
      control === 'night' ? '#404040' : '#cccccc'
    )
    document.documentElement.style.setProperty(
      '--nav',
      control === 'night' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)'
    )
  }

  useEffect(() => {
    changeMode()
  }, [control, time])

  return (
    <footer className="footer">
      <section className="section">
        <section className="Subscribe-section">
          <div className="container Subscribe">
            <div className="Subscribe--Content PageHeader-large">
              <div>
                <header>
                  <h1 className="PageHeader--Title">
                    Get free access to our monthly memoirs.
                  </h1>
                </header>
                <form action="/">
                  <Input
                    type="email"
                    name="visitors-name"
                    id="name"
                    label="Give an email, get our memoirs"
                    placeholder="Give an email, get our memoirs"
                    withLabel={false}
                    buttonText="Get access"
                  />
                </form>
              </div>
            </div>
          </div>
        </section>
      </section>
      <div className="container">
        <div className="Site-tag">
          <Logo />
        </div>
        <nav
          className="footer_nav"
          role="navigation"
          aria-label="Philemo—nn Directory"
        >
          <section className="nav_group relative">
            <input type="checkbox" id="our-services"></input>
            <label htmlFor="our-services">
              <h3 className="nav_group_title">Our Services</h3>
            </label>
            <a href="#our-services" className="nav_group_list_toggle">
              <span>View More</span>
            </a>
            <ul className="nav_group_list">
              <li>
                <Link to="/brand-design/">Brand Design</Link>
              </li>
              <li>
                <Link to="/brand-design/event-branding/">Event Branding</Link>
              </li>
              <li>
                <Link to="/graphic-design/">Visual Communications</Link>
              </li>
              <li>
                <Link to="/graphic-design/">Graphic Design</Link>
              </li>
              <li>
                <Link to="/graphic-design/">Books & Publication Design</Link>
              </li>
              <li>
                <Link to="/ui-ux/">UI/UX Design</Link>
              </li>
              <li>
                <Link to="/ui-ux/">Web Design & Development</Link>
              </li>
            </ul>
          </section>
          <section className="nav_group relative">
            <input type="checkbox" id="about-us"></input>
            <label htmlFor="about-us">
              <h3 className="nav_group_title">About Philemo—nn</h3>
            </label>
            <a href="#about-us" className="nav_group_list_toggle">
              <span>View More</span>
            </a>
            <ul className="nav_group_list">
              <li>
                <Link to="/stories/">Stories</Link>
              </li>
              <li>
                <Link to="/people/">People</Link>
              </li>
              <li>
                <Link to="/our-work/">Our Work</Link>
              </li>
              <li>
                <Link to="/support/contact-us/">Contact Us</Link>
              </li>
            </ul>
          </section>
          <section className="nav_group relative">
            <input type="checkbox" id="join-us"></input>
            <label htmlFor="join-us">
              <h3 className="nav_group_title">Join Our Community</h3>
            </label>
            <a href="#join-us" className="nav_group_list_toggle">
              <span>View More</span>
            </a>
            <ul className="nav_group_list">
              <li>
                <details>
                  <summary>Follow us on Social</summary>
                  <TradLink
                    text="Twitter"
                    href="https://twitter.com/philemonnco"
                  />
                  <TradLink text="Facebook" href="https://facebook.com/" />
                  <TradLink text="Instagram" href="https://instagram.com/" />
                </details>
              </li>
              <li>
                <a target="_blank" href="/stories">
                  The Tri—bbe
                </a>
              </li>
            </ul>
          </section>
          <section className="nav_group relative">
            <input type="checkbox" id="support"></input>
            <label htmlFor="support">
              <h3 className="nav_group_title">Support</h3>
            </label>
            <a href="#support" className="nav_group_list_toggle">
              <span>View More</span>
            </a>
            <ul className="nav_group_list">
              <li>
                <Link to="/support/contact-us/">Ask About Our Rates</Link>
              </li>
              <li>
                <Link to="/support/contact-us/">Hire Us to Speak</Link>
              </li>
              <li>
                <Link to="/support/schedule-meeting/">Schedule A Meeting</Link>
              </li>
              <li>
                <Link to="/support/">FAQs</Link>
              </li>
            </ul>
          </section>
        </nav>
        <div className="flex-container">
          <button onClick={() => onClick()} className="mode">
            {`Go to ${control === 'night' ? 'day' : 'night'} mode`}
          </button>
        </div>
        <section className="credits">
          <div>Copyright © 2020 Philemo—nn Ltd. All rights reserved.</div>
          <div>
            <p>
              Privacy Policy
              <span>
                <svg height="20" width="20">
                  <circle
                    cx="12"
                    cy="12"
                    r="2"
                    stroke="none"
                    fill="var(--primary)"
                  />
                </svg>
              </span>
              Terms and Conditions
              <span>
                <svg height="20" width="20">
                  <circle
                    cx="12"
                    cy="12"
                    r="2"
                    stroke="none"
                    fill="var(--primary)"
                  />
                </svg>
              </span>
              Legal
              <span>
                <svg height="20" width="20">
                  <circle
                    cx="12"
                    cy="12"
                    r="2"
                    stroke="none"
                    fill="var(--primary)"
                  />
                </svg>
              </span>
              Sitemap
            </p>
          </div>
        </section>
      </div>
    </footer>
  )
}
